import { render, staticRenderFns } from "./resultPop.vue?vue&type=template&id=a3bb98ba&scoped=true&"
import script from "./resultPop.vue?vue&type=script&lang=js&"
export * from "./resultPop.vue?vue&type=script&lang=js&"
import style0 from "./resultPop.vue?vue&type=style&index=0&id=a3bb98ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bb98ba",
  null
  
)

export default component.exports